import { Controller } from "@hotwired/stimulus";

export default class extends Controller<HTMLElement> {
  static targets = ["light", "dark"];

  declare readonly lightTarget: HTMLElement;
  declare readonly darkTarget: HTMLElement;

  private colorSchemeQuery?: MediaQueryList;

  connect() {
    this.colorSchemeQuery = window.matchMedia("(prefers-color-scheme: dark)");
    this.syncToColorScheme();

    if ("addEventListener" in this.colorSchemeQuery) {
      this.colorSchemeQuery.addEventListener("change", this.syncToColorScheme);
    } else {
      this.colorSchemeQuery.addListener(this.syncToColorScheme);
    }
  }

  disconnect() {
    if (!this.colorSchemeQuery) return;

    if ("removeEventListener" in this.colorSchemeQuery) {
      this.colorSchemeQuery.removeEventListener("change", this.syncToColorScheme);
    } else {
      this.colorSchemeQuery.removeListener(this.syncToColorScheme);
    }
  }

  swap() {
    this.bringToFront(this.firstItem === this.darkTarget ? this.lightTarget : this.darkTarget);
  }

  swapWithKeyboard(event: KeyboardEvent) {
    if (event.key !== "Enter" && event.key !== " ") return;

    event.preventDefault();
    this.swap();
  }

  private syncToColorScheme = () => {
    this.bringToFront(this.colorSchemeQuery?.matches ? this.darkTarget : this.lightTarget);
  };

  private bringToFront(item: HTMLElement) {
    this.element.prepend(item);
  }

  private get firstItem() {
    return this.element.firstElementChild;
  }
}
